import React from 'react';
import { connect } from 'react-redux';
import PostsList from './component';
import Loader from '../../../../components/Loader';
import fetchBlogPosts from '../../../../modules/blog/actions';
import deleteBlogPost from '../../../../modules/blog/deleteBlogPost';

class PostsListContainer extends React.Component {

  componentWillMount() {
    this.props.fetchBlogPosts();
  }
  render() {
    const { loading, posts, deleteBlogPost } = this.props;
    if (loading) {
      return (
        <Loader />
      )
    }
    return (
      <PostsList posts={posts} deleteBlogPost={deleteBlogPost} />
    )
  }
}

function mapStateToProps(state) {
  return {
    posts: state.blogPosts.posts,
    loading: state.blogPosts.loading,
  }
}


const mapActionsToProps = {
  fetchBlogPosts,
  deleteBlogPost,
};

export default connect(mapStateToProps, mapActionsToProps)(PostsListContainer)


// WEBPACK FOOTER //
// ./src/pages/Admin/BlogCollection/PostsList/container.js